module.exports = __webpack_public_path__ + "RajivChavali-bc474e4e.webp";